import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation()
  const [displayChildren, setDisplayChildren] = useState(children)
  const [transitionState, setTransitionState] = useState<'entering' | 'visible'>('visible')
  const prevKeyRef = useRef(location.key)

  useEffect(() => {
    if (location.key === prevKeyRef.current) return
    prevKeyRef.current = location.key

    setTransitionState('entering')
    setDisplayChildren(children)

    const timer = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTransitionState('visible')
      })
    })

    return () => cancelAnimationFrame(timer)
  }, [location.key, children])

  return (
    <div
      style={{
        opacity: transitionState === 'entering' ? 0 : 1,
        transform: transitionState === 'entering' ? 'translateY(8px)' : 'translateY(0)',
        transition: 'opacity 0.22s ease, transform 0.22s ease',
        height: '100%'
      }}
    >
      {displayChildren}
    </div>
  )
}
